export default __webpack_public_path__ + "static/media/projectsix.923727ea.jpg";